import api from '../utils/api';

export const yardVehicleService = {
  getMeta: async () => {
    const res = await api.get('/seller/yard-vehicles/meta');
    return res.data?.data;
  },

  vahanCheck: async (payload) => {
    const res = await api.post('/seller/yard-vehicles/vahan-check', payload);
    return res.data?.data;
  },

  create: async (payload) => {
    const res = await api.post('/seller/yard-vehicles', payload);
    return res.data?.data;
  },

  list: async (params = {}) => {
    const res = await api.get('/seller/yard-vehicles', { params });
    return res.data?.data?.vehicles || [];
  },

  suggestParts: async (vehicleId) => {
    const res = await api.get(`/seller/yard-vehicles/${vehicleId}/suggest-parts`);
    return res.data?.data;
  },

  priceCheck: async (vehicleId, payload) => {
    const res = await api.post(`/seller/yard-vehicles/${vehicleId}/price-check`, payload);
    return res.data?.data;
  },

  publishCheck: async (vehicleId) => {
    const res = await api.get(`/seller/yard-vehicles/${vehicleId}/publish-check`);
    return res.data?.data;
  },

  publishParts: async (vehicleId, payload) => {
    const res = await api.post(`/seller/yard-vehicles/${vehicleId}/publish-parts`, payload);
    return res.data?.data;
  },

  getOne: async (vehicleId) => {
    const res = await api.get(`/seller/yard-vehicles/${vehicleId}`);
    return res.data?.data?.vehicle;
  },
};

export default yardVehicleService;
